declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, PurchaseIndentsListController, PurchaseIndentsListRequest, PurchaseOrdersListController, PurchaseOrdersListRequest, GenericProcPostRequest, S_Methods } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'searchpurchaseorders',
  templateUrl: './searchpurchaseorders.modal.html',
  styleUrls: ['./searchpurchaseorders.modal.scss']
})

export class NgbSearchPurchaseOrdersModal implements OnInit {

  SelectedFromDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  public searchValue: any;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  TodayDate = new Date();

  CurrentPurchaseOrdersListController: PurchaseOrdersListController[];
  CurrentPurchaseOrderHeaderDetailsController: PurchaseOrdersListController;
  CurrentPurchaseOrdersListRequest: PurchaseOrdersListRequest;

  LoadOrders() {
    this.CurrentPurchaseOrdersListRequest = new PurchaseOrdersListRequest();
    this.CurrentPurchaseOrdersListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseOrdersListController();
  }
  GetPurchaseOrdersListController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrdersListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseOrdersListRequest.FromDate = new Date();
    this.CurrentPurchaseOrdersListRequest.ToDate = new Date();
    this.CurrentPurchaseOrdersListRequest.PurchaseOrderCode = 0;
    this.CurrentPurchaseOrdersListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrdersListController(this.CurrentPurchaseOrdersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseOrdersListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  LoadOrdersGeneric() {
    var getReq = new PurchaseOrdersListRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101040;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    getReq.PurchaseOrderCode = 0;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101040;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentPurchaseOrdersListController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  dataChanged(newobj) {

    //this._GetPurchaseOrdersListController();
    this._LoadOrdersGeneric();
  }
  _GetPurchaseOrdersListController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrdersListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseOrdersListRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPurchaseOrdersListRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPurchaseOrdersListRequest.PurchaseOrderCode = 0;
    this.CurrentPurchaseOrdersListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrdersListController(this.CurrentPurchaseOrdersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseOrdersListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  _LoadOrdersGeneric() {
    var getReq = new PurchaseOrdersListRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101040;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    //getReq.PurchaseOrderCode = 0;
    getReq.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    getReq.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101040;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentPurchaseOrdersListController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  DecrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this._GetPurchaseOrdersListController();
    this._LoadOrdersGeneric();
  }
  IncrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this._GetPurchaseOrdersListController();
    this._LoadOrdersGeneric();
  }

  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number = 0;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {

    //this.LoadOrders();
    this.LoadOrdersGeneric();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

  }
  //SelectedOrder(l: PurchaseOrdersListController) {
  //  this.router.navigate(['healins/invoicereceipt', {
  //    DocIDdata: l.DocID, PurchaseOrderCode: l.PurchaseOrderCode, OrderStatus: l.OrderStatus, ShipToLocationCode: l.ShipToLocationCode,
  //    ShipToLocationdata: l.ShipToLocation, SupplierCode: l.SupplierCode, SupplierName: l.SupplierName, RefNo: l.RefNo,
  //    OrderDate: l.OrderDate, DeliveryDate: l.DeliveryDate,
  //    Tax: l.Tax, GrandTotal: l.GrandTotal, TotalBeforeDiscount: l.TotalBeforeDiscount, BranchName: l.ShortName
  //  }]);
  //    this.activeModal.close();
  //}
  SelectedOrder(l: PurchaseOrdersListController) {
    this.router.navigate(['healins/invoicereceipt_disc', {
      DocIDdata: l.DocID, PurchaseOrderCode: l.PurchaseOrderCode, OrderStatus: l.OrderStatus, ShipToLocationCode: l.ShipToLocationCode,
      ShipToLocationdata: l.ShipToLocation, SupplierCode: l.SupplierCode, SupplierName: l.SupplierName, RefNo: l.RefNo,
      OrderDate: l.OrderDate, DeliveryDate: l.DeliveryDate,
      Tax: l.Tax, GrandTotal: l.GrandTotal, TotalBeforeDiscount: l.TotalBeforeDiscount, BranchName: l.ShortName,
      DiscountAmount: l.DiscountAmount
    }]);
    this.activeModal.close();
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}

